import { Navigate } from 'react-router-dom';
import { useLink } from '~/hooks/link';
import { useLandingPath } from './landing';

export const LandingRedirect = () => {
  const link = useLink();
  return <Navigate replace to={link(useLandingPath())} />;
};
